import { defaultTheme, defaultDarkTheme } from "react-admin";
import { deepmerge } from "@mui/utils";

// stessi colori del sito pubblico (src/theme.ts su dinamo-ostia-web)
const BRAND_NAVY = "#183060";
const BRAND_NAVY_DARK = "#12224a";
const BRAND_BLUE_LIGHT = "#5b82c4";

const fontFamily = [
  "system-ui",
  "-apple-system",
  "Segoe UI",
  "Roboto",
  "Arial",
  "sans-serif",
].join(",");

export const lightTheme = deepmerge(defaultTheme, {
  palette: {
    primary: { main: BRAND_NAVY },
    secondary: { main: "#586888" },
    background: { default: "#F5F7FA" },
  },
  shape: { borderRadius: 12 },
  typography: { fontFamily },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundColor: BRAND_NAVY },
      },
    },
  },
});

export const darkTheme = deepmerge(defaultDarkTheme, {
  palette: {
    primary: { main: BRAND_BLUE_LIGHT },
    secondary: { main: "#8fa4c7" },
  },
  shape: { borderRadius: 12 },
  typography: { fontFamily },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: { backgroundColor: BRAND_NAVY_DARK },
      },
    },
  },
});
